<template>
    <div class="order-detail-section mg20">
        <h3>第三方合作参数</h3>
        <div>
            <el-row class="order-pad20">
            <p>AppID：{{AppID}}</p>
            <p>AppSecret：{{AppSecret}}</p>
            </el-row>
        </div>
    </div>
</template>
<script>
    import CommonService from "~/services/common";
    export default {
        props:{
            order:{
                required: true
            },
        },
        data(){
          return {
              AppID:'',
              AppSecret:'',
          }
        },
        watch:{
            order(d,v){
                this.order = d;
                this.getAppInfo();
            }
        },
        methods:{
            getAppInfo(){
                CommonService.getCorpInfo({customer_id:this.order.customer_id}).then(res=>{
                    if(!res.code){
                        this.AppID = res.data['appKey'];
                        this.AppSecret = res.data['appSecret'];
                    }
                });
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_corp.vue